var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { $modal } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { getErrorPath } from '../../Notes.helpers';
import { useResourceBlock } from './ResourceBlock.hooks';
import styles from './ResourceBlockItem.module.scss';
const ResourceBlock = ({ $block, resource, className }) => {
    const { ModalComponent, meta, rightMeta, rightValue, value, code } = useResourceBlock($block, resource);
    const isInvalid = Object.values($block.errors).some((x) => {
        return x.has(getErrorPath($block.sectionId, $block.ref, resource.id));
    });
    const handleClick = useCallback(() => {
        if (!ModalComponent)
            return;
        $modal.add(ModalComponent, {
            encounterId: $block.encounterId,
            resourceId: resource.id,
            resourceContext: $block.resourceContext,
            practiceSettings: $block.section.practiceSettings,
            onDone: () => __awaiter(void 0, void 0, void 0, function* () {
                yield $block.parent.refresh();
            }),
        });
    }, [resource, isInvalid]);
    return (_jsxs("div", Object.assign({ id: `ref_${resource.id}`, className: classNames(styles.resourceBlock, !$block.blocked && $block.touched && styles.blue, $block.source === 'system' && $block.blocked && styles.purple, !$block.blocked && ModalComponent && styles.clickable, isInvalid && styles.hasError, className), onClick: $block.blocked ? undefined : handleClick }, { children: [_jsxs("div", Object.assign({ className: styles.content }, { children: [_jsxs("div", Object.assign({ className: styles.value }, { children: [_jsx("div", Object.assign({ className: styles.code }, { children: code })), _jsx("div", Object.assign({ className: styles.title }, { children: value }))] })), meta && _jsx("div", Object.assign({ className: styles.meta }, { children: meta }))] })), (rightValue || rightMeta) && (_jsxs("div", Object.assign({ className: styles.right }, { children: [rightValue && _jsx("div", Object.assign({ className: styles.value }, { children: rightValue })), rightMeta && _jsx("div", Object.assign({ className: styles.meta }, { children: rightMeta }))] })))] })));
};
export default observer(ResourceBlock);
